// extracted by mini-css-extract-plugin
export default {"cart_card":"CartCard_cart_card__hvha7","card_title":"CartCard_card_title__xTMZ0","card_count":"CartCard_card_count__xTUrG"};